import {pageTransitionKey} from './storage/routeKey';
import StaffHomeMediaFolder from './home_media_ui/StaffFolder';
import theme from './theme';
import PerformerLanding from './pages/PerformerLanding';
import UploadProvider from './storage/UploadProvider';
import { StoragePage, PublicStoragePage } from './storage/pages';
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router';
import { getAuthToken } from './auth';
import './App.css';
import LayoutProvider, { LayoutContext } from './context';
import LKPage from './content/Manager/LKPage';
import { useCallback, useContext, useEffect, useRef, useState, lazy, Suspense } from 'react';
import LockPage from './pages/LockPage';
import { CssVarsProvider } from '@mui/joy';
import Cookies from "js-cookie";

import 'leaflet/dist/leaflet.css';

import { AnimatePresence, motion } from 'framer-motion';
import ModalQuest from './components/Modals/ModalQuest';
import ModalConfirmDeleteFile from './components/Modals/ModalConfirmDeleteFile';
import LKPageDraftsman from './content/Draftsman/LKPageDraftsman';
import ManagerPage from './content/Manager/ManagerPage';
import DraftsmanPage from './content/Draftsman/DraftsmanPage';
import QualityPage from './content/Draftsman/QualityPage';
import ClientPaymentsPage from './content/Manager/ClientPaymentsPage';
import ModalAddService from './components/Modals/ModalAddService';
import FinancePage from './content/Manager/Finance/FinancePage';
import MessagesPage from './content/Manager/MessagesPage';
import NotificationBell from './components/MessagesChat/NotificationBell';
import ModalReviewEmployee from './components/Modals/ModalReviewEmployee';
import ModalPaymentBreakdown from './components/Modals/ModalPaymentBreakdown';
import PerformersPage from './content/Manager/PerformersPage';
import ModalEmployee from './components/Modals/ModalEmployee';
import PWAInstallBanner from './PWAInstallBanner';
import SurveyorHomePage from './content/Surveyor/SurveyorPage';
import LKPageSurveyor from './content/Surveyor/LKPageSurveyor';
import ModalMyProfile from './components/Modals/ModalMyProfile';
import SurveyorCalendarPage from './content/Surveyor/SurveyorCalendarPage';
// import ModalCompleteEventSurveyor from './components/Modals/ModalCompleteEventSurveyor';
import ModalKonsolConnect from './components/Modals/ModalKonsolConnect';
// import ModalFailEventSurveyor from './components/Modals/ModalFailEventSurveyor';
// Дополнение обмера и дозамер открываются на SurveyorSupplementPage.
import ModalOverdueEvents from './components/Modals/ModalOverdueEvents';
import { GlobalErrorBoundary, LocalErrorBoundary } from './GlobalErrorBoundary';
import ModalTestPush from './components/Modals/ModalTestPush';
import ModalIOSNotifHelp from './components/Modals/ModalIOSNotifHelp';
import ModalDispatchResponses from "./components/Modals/ModalDispatchResponses";
import SurveyorFailPage from './pages/SurveyorFailPage';
import SurveyorArrivePage from './pages/SurveyorArrivePage';
import QualityGoalsPage from './content/Manager/QualityGoalsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SurveyorSupplementPage from './pages/SurveyorSupplementPage';
import SurveyorEventDetailPage from './pages/SurveyorEventDetailPage';
import MyPaymentsPage from './pages/MyPaymentsPage';

import RouteLoader from './components/RouteLoader';
import RoleLayout from './components/RoleLayout';
import Toasts from './components/Toasts';
import NotFoundPage from './pages/NotFoundPage';
import NoAccessPage from './pages/NoAccessPage';
import SurveyorDispatchesPage from './pages/SurveyorDispatchesPage';
import NotificationsPanel from './components/HeaderLK/NotificationsPanel';
import PushPrompt from './components/PushPrompt';
import NewsStoriesModal from './components/News/NewsStoriesModal';
import NewsAdminPage from './content/Manager/News/NewsAdminPage';
import DocumentsPage from './content/Manager/Documents/DocumentsPage';
import DocumentSettingsPage from './settings/DocumentSettingsPage';
import NewsEditorPage from './content/Manager/News/NewsEditorPage';
import NewsStatsPage from './content/Manager/News/NewsStatsPage';
import { getHomePathForRole, isSurveyor, isAnyManager, rolesForPath, permissionForPath } from './roles';
import { canOpenCabinetPath } from './cabinetAccess';
import { initTracker, track, setTrackerPath } from './utils/tracker';

// Обёртка над lazy: при сбое загрузки чанка (обычно после нового деплоя — старые
// хеши чанков пропали) один раз перезагружаем страницу. Защита от петли — не чаще
// раза в 10 секунд.
function lazyWithRetry(factory) {
    return lazy(() =>
        factory().catch((err) => {
            const KEY = 'chunk_reload_ts';
            const last = Number(sessionStorage.getItem(KEY) || 0);
            if (Date.now() - last > 10000) {
                sessionStorage.setItem(KEY, String(Date.now()));
                window.location.reload();
                return new Promise(() => {});   // висим до перезагрузки (Suspense держит fallback)
            }
            throw err;   // повторно не зацикливаемся — пробрасываем ошибку
        })
    );
}

const ModalEvent = lazyWithRetry(() => import('./components/Modals/ModalEvent'));
const ModalApplication = lazyWithRetry(() => import('./components/Modals/ModalApplication'));
const PaymentsPage = lazyWithRetry(() => import('./content/Manager/PaymentsPage'));
const ClientsPage = lazyWithRetry(() => import('./content/Manager/ClientsPage'));
const StatisticsPage = lazyWithRetry(() => import('./content/Manager/StatisticsPage'));
const ActivityLogsPage = lazyWithRetry(() => import('./content/Manager/ActivityLogsPage'));
const ModalEventSurveyor = lazyWithRetry(() => import('./components/Modals/ModalEventSurveyor'));
const KnowledgeBasePage = lazyWithRetry(() => import('./content/KnowledgeBasePage'));
const ChatModal = lazyWithRetry(() => import('./components/Modals/ChatModal'));
const KnowledgeArticlePage = lazyWithRetry(() => import('./content/KnowledgeArticlePage'));
const SurveyorClosePage = lazyWithRetry(() => import('./pages/SurveyorClosePage'));
const ApplicationsPage = lazyWithRetry(() => import('./content/Manager/ApplicationsPage'));
const GoalsPage = lazyWithRetry(() => import('./content/Manager/GoalsPage'));
const ServicesTariffsPage = lazyWithRetry(() => import('./content/Manager/ServicesTariffsPage'));
const ConstructorPage = lazyWithRetry(() => import('./content/Constructor/ConstructorPage'));
const AccessControlPage = lazyWithRetry(() => import('./content/Manager/AccessControlPage'));
const ChatSettingsPage = lazyWithRetry(() => import('./settings/ChatSettingsPage'));


const ProtectedRoute = ({ children, allowedRoles }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { effectiveRole, accountLoaded, account } = useContext(LayoutContext);
  const roles = allowedRoles ?? rolesForPath(location.pathname);
  const hasAccess = canOpenCabinetPath(location.pathname, account, effectiveRole,
    roles, permissionForPath(location.pathname));
  const home = getHomePathForRole(effectiveRole);

  useEffect(() => {
    if (accountLoaded && effectiveRole && !hasAccess && location.pathname !== home) {
      navigate(home, { replace: true });
    }
  }, [accountLoaded, effectiveRole, hasAccess, home, location.pathname, navigate]);

  if (!accountLoaded) return <RouteLoader />;
  if ((!effectiveRole && !hasAccess) || (!hasAccess && location.pathname === home)) return <NoAccessPage />;
  if (!hasAccess) return <RouteLoader />;
  return children;
};


function AnimatePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { account, modalTestPush, setModalTestPush, effectiveRole, modalEvent, modalApplication, chatModal } = useContext(LayoutContext);
  const effectivePositions = effectiveRole ? [effectiveRole] : account?.position;

  // Тяжёлые модалки события/заявки грузим лениво: монтируем при первом открытии
  // и оставляем смонтированными дальше — анимации закрытия и состояние как раньше.
  const [modalEventSeen, setModalEventSeen] = useState(false);
  const [modalApplicationSeen, setModalApplicationSeen] = useState(false);
  const [chatModalSeen, setChatModalSeen] = useState(false);
  useEffect(() => { if (modalEvent?.open) setModalEventSeen(true); }, [modalEvent?.open]);
  useEffect(() => { if (modalApplication?.open) setModalApplicationSeen(true); }, [modalApplication?.open]);
  useEffect(() => { if (chatModal?.open) setChatModalSeen(true); }, [chatModal?.open]);

  // ── Трекинг действий пользователя: инициализация + переходы (page_view) ──
  const lastTrackedPath = useRef(null);
  useEffect(() => { initTracker(); }, []);
  useEffect(() => {
    const p = location.pathname;
    setTrackerPath(p);
    if (lastTrackedPath.current === p) return;   // защита от двойного срабатывания
    const from = lastTrackedPath.current;
    lastTrackedPath.current = p;
    track('frontend.page_view', {
      title: `Просмотр: ${p}`,
       meta: { from: from || '', search: location.search || '' },
    });
  }, [location.pathname, location.search]);


  const activeRole = localStorage.getItem('active_role') 
    || (Array.isArray(account?.position) ? account.position[0] : null);

  return (
    <CssVarsProvider
      theme={theme}
    >
      <AnimatePresence mode='wait'>
        <Suspense fallback={<RouteLoader />}>
        <Routes location={location} key={pageTransitionKey(location.pathname)}>
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/constructor" element={<ProtectedRoute><ConstructorPage /></ProtectedRoute>} />
          <Route path="/constructor/event/:eventId" element={<ProtectedRoute><ConstructorPage /></ProtectedRoute>} />
          <Route path="/constructor/:uid" element={<ProtectedRoute><ConstructorPage /></ProtectedRoute>} />

          <Route path="/" element={<RoleLayout />}>
              <Route path="storage/events/:objectId/:section" element={<ProtectedRoute><StaffHomeMediaFolder /></ProtectedRoute>} /> {/* HOME_MEDIA_V2_ROUTE */}
              <Route path="storage/:folderId?" element={<StoragePage />} />
              {/* Главная — для всех ролей кроме draftsman */}
              <Route index element={
                  <ProtectedRoute>
                      {isSurveyor(effectiveRole) ? <SurveyorHomePage /> : <ManagerPage />}
                  </ProtectedRoute>
              } />

              {/* Менеджерские разделы */}
              <Route path="payments" element={
                  <ProtectedRoute>
                      <PaymentsPage />
                  </ProtectedRoute>
              } />
              <Route path="client-payments" element={
                  <ProtectedRoute>
                      <ClientPaymentsPage />
                  </ProtectedRoute>
              } />
              <Route path="clients" element={
                  <ProtectedRoute>
                      <ClientsPage />
                  </ProtectedRoute>
              } />
              <Route path="documents/settings" element={<ProtectedRoute><DocumentSettingsPage /></ProtectedRoute>} />
              <Route path="documents" element={
                  <ProtectedRoute>
                      <LocalErrorBoundary name="Документы">
                          <DocumentsPage />
                      </LocalErrorBoundary>
                  </ProtectedRoute>
              } />
              <Route path="services-tariffs" element={
                  <ProtectedRoute>
                      <ServicesTariffsPage />
                  </ProtectedRoute>
              } />
              <Route path="goals" element={
                  <ProtectedRoute>
                      <GoalsPage />
                  </ProtectedRoute>
              } />
              <Route path="quality-goals" element={
                  <ProtectedRoute>
                      <QualityGoalsPage />
                  </ProtectedRoute>
              } />
              <Route path="statistics" element={
                  <ProtectedRoute>
                      <StatisticsPage />
                  </ProtectedRoute>
              } />
              <Route path="finance" element={
                  <ProtectedRoute>
                      <FinancePage />
                  </ProtectedRoute>
              } />
              <Route path="performers" element={
                  <ProtectedRoute>
                      <PerformersPage />
                  </ProtectedRoute>
              } />
              <Route path="activity-logs" element={
                  <ProtectedRoute>
                      <LocalErrorBoundary name="Логи действий">
                          <ActivityLogsPage />
                      </LocalErrorBoundary>
                  </ProtectedRoute>
              } />
              <Route path="access" element={
                  <ProtectedRoute>
                      <LocalErrorBoundary name="Управление доступом">
                          <AccessControlPage />
                      </LocalErrorBoundary>
                  </ProtectedRoute>
              } />
              <Route path="settings/*" element={
                  <ProtectedRoute>
                      <LocalErrorBoundary name="Настройки чатов">
                          <ChatSettingsPage />
                      </LocalErrorBoundary>
                  </ProtectedRoute>
              } />
              <Route path="applications" element={
                  <ProtectedRoute>
                      <ApplicationsPage />
                  </ProtectedRoute>
              } />

              {/* Новости — только руководитель и админ */}
              <Route path="news" element={
                  <ProtectedRoute>
                      <LocalErrorBoundary name="Новости">
                          <NewsAdminPage />
                      </LocalErrorBoundary>
                  </ProtectedRoute>
              } />
              <Route path="news/:id/stats" element={
                  <ProtectedRoute>
                      <LocalErrorBoundary name="Статистика новости">
                          <NewsStatsPage />
                      </LocalErrorBoundary>
                  </ProtectedRoute>
              } />
              <Route path="news/:id" element={
                  <ProtectedRoute>
                      <LocalErrorBoundary name="Редактор новости">
                          <NewsEditorPage />
                      </LocalErrorBoundary>
                  </ProtectedRoute>
              } />

              {/* Раздел обмерщика */}
              <Route path="surveyor/calendar" element={
                  <ProtectedRoute allowedRoles={['surveyor']}><SurveyorCalendarPage /></ProtectedRoute>
              } />
              <Route path="surveyor/close/:bitrixId" element={
                  <ProtectedRoute allowedRoles={['surveyor']}><SurveyorClosePage /></ProtectedRoute>
              } />
              <Route path="surveyor/close" element={
                  <ProtectedRoute allowedRoles={['surveyor']}><SurveyorClosePage /></ProtectedRoute>
              } />
              <Route path="surveyor/fail/:bitrixId" element={
                  <ProtectedRoute allowedRoles={['surveyor']}><SurveyorFailPage /></ProtectedRoute>
              } />
              <Route path="surveyor/fail" element={
                  <ProtectedRoute allowedRoles={['surveyor']}><SurveyorFailPage /></ProtectedRoute>
              } />
              <Route path="surveyor/arrive/:eventId" element={
                <ProtectedRoute allowedRoles={['surveyor']}><SurveyorArrivePage /></ProtectedRoute>
              } />
              <Route path="surveyor/supplement/:bitrixId" element={
                  <ProtectedRoute allowedRoles={['surveyor']}><SurveyorSupplementPage /></ProtectedRoute>
              } />
              <Route path="surveyor/supplement" element={
                  <ProtectedRoute allowedRoles={['surveyor']}><SurveyorSupplementPage /></ProtectedRoute>
              } />
              <Route path="surveyor/event/:bitrixId" element={
                  <ProtectedRoute allowedRoles={['surveyor']}>
                      <LocalErrorBoundary name="Детали события">
                          <SurveyorEventDetailPage />
                      </LocalErrorBoundary>
                  </ProtectedRoute>
              } />
              <Route path="surveyor/dispatches" element={
                  <ProtectedRoute allowedRoles={['surveyor']}><SurveyorDispatchesPage /></ProtectedRoute>
              } />

              {/* Общие */}
              <Route path="my-payments" element={
                  <ProtectedRoute allowedRoles={['draftsman', 'surveyor']}>
                      <MyPaymentsPage />
                  </ProtectedRoute>
              } />
              <Route path="chats" element={
                  <ProtectedRoute allowedRoles={['draftsman', 'surveyor', 'manager', 'quality_master', 'head_manager']}>
                      <MessagesPage />
                  </ProtectedRoute>
              } />
              <Route path="knowledge" element={
                  <ProtectedRoute allowedRoles={['draftsman', 'surveyor', 'manager', 'quality_master', 'head_manager']}>
                      <KnowledgeBasePage />
                  </ProtectedRoute>
              } />
              <Route path="knowledge/new" element={
                  <ProtectedRoute allowedRoles={['draftsman', 'surveyor', 'manager', 'quality_master', 'head_manager']}>
                      <KnowledgeArticlePage />
                  </ProtectedRoute>
              } />
              <Route path="knowledge/:id" element={
                  <ProtectedRoute allowedRoles={['draftsman', 'surveyor', 'manager', 'quality_master', 'head_manager']}>
                      <KnowledgeArticlePage />
                  </ProtectedRoute>
              } />

              {/* Раздел чертёжника */}
              <Route path="draftsman" element={
                  <ProtectedRoute allowedRoles={['draftsman']}>
                      <DraftsmanPage />
                  </ProtectedRoute>
              } />

              {/* Контроль качества — кабинет тот же, что у чертёжника.
                  Список ролей НЕ передаём: путь есть в SECTION_ROLES, и это
                  единственный источник правды — иначе меню и маршрут снова
                  разойдутся. Сам путь помечен как «по должности»
                  (POSITION_BASED_SECTIONS), поэтому активная роль чертёжника
                  доступ не перекрывает. */}
              <Route path="quality" element={
                  <ProtectedRoute>
                      <QualityPage />
                  </ProtectedRoute>
              } />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </Suspense>
        
        <PWAInstallBanner />
        <NotificationsPanel />

        <LocalErrorBoundary name="Предложение уведомлений">
          <PushPrompt />
        </LocalErrorBoundary>

        <LocalErrorBoundary name="Сторис новостей">
          <NewsStoriesModal />
        </LocalErrorBoundary>
        
        {isAnyManager(effectiveRole) && modalEventSeen && (
          <Suspense fallback={null}><ModalEvent/></Suspense>
        )}
        {isAnyManager(effectiveRole) && modalApplicationSeen && (
          <Suspense fallback={null}><ModalApplication/></Suspense>
        )}
        {effectiveRole?.includes('surveyor') && modalEventSeen && (
          <Suspense fallback={null}><ModalEventSurveyor/></Suspense>
        )}
        {effectiveRole?.includes('surveyor') && <ModalOverdueEvents />}

        <ModalAddService/>
        <ModalQuest/>
        <ModalConfirmDeleteFile/>
        <NotificationBell />
        <ModalReviewEmployee />
        <ModalPaymentBreakdown />
        <ModalMyProfile />
        <Toasts />

        <ModalTestPush
          open={modalTestPush}
          onSuccess={() => setModalTestPush(false)}
          onRetry={() => {}}
        />

        <ModalIOSNotifHelp />
        
        <LocalErrorBoundary name="Модальное окно чатов">
          {chatModalSeen && (
            <Suspense fallback={null}><ChatModal /></Suspense>
          )}
        </LocalErrorBoundary>
        
        <LocalErrorBoundary name="Модальное окно консолиPRO">
          <ModalKonsolConnect />
        </LocalErrorBoundary>
        
        {/* Загрузка дополнения/дозамера — только отдельная страница. */}

        {/* <LocalErrorBoundary name="Завершение обмера">
          <ModalCompleteEventSurveyor />
        </LocalErrorBoundary> */}
        
        {/* <LocalErrorBoundary name="Отмена обмера">
          <ModalFailEventSurveyor />
        </LocalErrorBoundary> */}

        <LocalErrorBoundary name="Модальное окно Исполнителя">
          <ModalEmployee />
        </LocalErrorBoundary>
        
        <LocalErrorBoundary name="Модальное окно Экран откликов">
          <ModalDispatchResponses />
        </LocalErrorBoundary>

      </AnimatePresence>
    </CssVarsProvider>
  );
}


function AppEntry() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const match = location.pathname.match(/^\/disk\/([A-Za-z0-9_-]{1,100})\/?$/);

  if (match) {
    return <UploadProvider publicToken={match[1]}><Routes><Route path="/disk/:token" element={<PublicStoragePage />} /></Routes></UploadProvider>;
  }

  const isLandingHost = window.location.hostname === 'pro.planium.tech';
  const isLandingPath = location.pathname === '/';
  const hasAuthRequest = params.has('auth') || params.has('token');
  const hasSavedToken = Boolean(getAuthToken());

  if (isLandingHost && isLandingPath && !hasAuthRequest && !hasSavedToken) {
    return <CssVarsProvider theme={theme} defaultMode="light"><PerformerLanding /></CssVarsProvider>;
  }

  return <LayoutProvider><UploadProvider><AnimatePage /></UploadProvider></LayoutProvider>;
}

function App() {
  return (
    <GlobalErrorBoundary>
      <BrowserRouter>
        <AppEntry />
      </BrowserRouter>
    </GlobalErrorBoundary>
  );
}

export default App;